const WalesSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112802)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20" fill="#496E2D" />
      <path
        d="M34.6105 13.9171C33.8953 11.8888 31.9627 10.4346 29.6897 10.4346H25.2175C22.336 10.4346 20.0001 12.7705 20.0001 15.652C20.0001 16.5934 20.2507 17.4982 20.6869 18.2607C19.0262 18.2471 17.4892 18.2721 16.5218 18.2607C16.5218 16.2485 16.5218 13.6852 16.5218 13.1489L16.7272 12.9434C17.6496 12.0211 17.342 10.4839 17.342 10.4839C17.342 10.4839 15.805 10.1764 14.8826 11.0988L13.8077 12.1737H12.6087C9.96732 12.1737 7.82615 14.315 7.82615 16.9563H11.3044V20.8693C11.3044 21.4417 11.4198 21.9869 11.6283 22.4835L10.4348 23.478H8.69568V21.7389H6.95654V25.2171H14.7826V28.6954H13.0435V30.4346H16.5218V26.9563L18.1159 25.0432H21.8841L23.4783 26.9563V28.6954H21.7391V30.4346H28.6956V20.8693C28.6956 19.4286 29.8636 18.2606 31.3043 18.2606C31.3413 18.2606 31.378 18.2619 31.4147 18.2634C31.3427 17.9846 31.3043 17.6924 31.3043 17.3911C31.3044 15.5279 32.7695 14.0069 34.6105 13.9171ZM25.2175 28.6954V25.0432H25.3624L26.9565 26.9562V28.6954H25.2175Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112802">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default WalesSvg;
